import { useQuery } from '@tanstack/react-query'
import { teamsService } from '../services/teamsService'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect } from 'react'

export const useTeamInfo = (id: string) => {
  const { data, isError, isFetching, isLoading, refetch } = useQuery({
    queryKey: ['teamId', id],
    queryFn: async () => await teamsService.getTeamById(id),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
    refetch,
  }
}
